import { NgModule } from '@angular/core';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { SidebarModule } from '@tablesready/frontend-nav-sidebar';
import { ClockModule } from '@tablesready/frontend-alerts-bar';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { GuiderModule } from '@tablesready/frontend-guider';
import { AppVariablesModule } from '@tablesready/frontend-variables';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { PipesModule } from './pipes';
import {
  ChatCounterModule,
  ConnectionAlertModule,
  FormValidationModule,
  LoaderModule,
  UtilsModule,
  SmsWarningModule,
  ConfirmationModule,
  TimepickerModule,
  ClickOutsideModule,
  SearchBarModule,
  NumberStepperModule,
} from './components';

const modules = [
  ConnectionAlertModule,
  PipesModule,
  FrontendIconsModule,
  AlertsModule,
  SearchBarModule,
  SidebarModule,
  ChatCounterModule,
  ClockModule,
  FormValidationModule,
  LoaderModule,
  StatusModule,
  UtilsModule,
  AppVariablesModule,
  ConfirmationModule,
  TimepickerModule,
  ClickOutsideModule,
  GuiderModule,
  SmsWarningModule,
  NumberStepperModule,
];

@NgModule({
  imports: [...modules],
  exports: [...modules],
})
export class CommonUiModule {}
